// @flow
import React from 'react';
import ratios from 'Components/utils/ratios/ratios.utils.js';
import Image from 'Components/frameworks/image/Image.jsx';

type Props = {
  imageSrc?: string,
  header?: string,
  text: string,
  tail?: string,
};

export function ProductSignatures(props: Props) {
  const { imageSrc, header, text, tail } = props;
  if (!text) return null;

  const image = <Image imageUrl={imageSrc} className="absolute pin-center" ratioKey={ratios.L} />;

  return (
    <article className="relative inset-border-after" style={{ padding: '7vw 30px' }}>
      <div className="bg-deepBlue rounded-tiny absolute inset-0">
        <div className="h-full relative opacity-50 image-responsive-cell overflow-y-hidden">
          {image}
        </div>
      </div>
      <div
        style={{ minHeight: '120px' }}
        className="relative text-base font-brand flex flex-col items-center justify-between text-center text-white"
      >
        <div>{header}</div>
        <div className="text-2xl sm:text-7xl">{text}</div>
        <div className="font-sans">{tail}</div>
      </div>
    </article>
  );
}
